import React, { useEffect, useState } from 'react';
const NAMES = ['María', 'Laura', 'Carolina', 'Alejandra', 'Gabriela', 'Luciana', 'Valeria', 'Daniela', 'Marcela', 'Patricia', 'Silvia', 'Andrea', 'Claudia', 'Romina', 'Verónica', 'Natalia', 'Florencia', 'Soledad', 'Cecilia', 'Mariana', 'Jorge', 'Fernando', 'Pablo', 'Roberto', 'Martín', 'Diego', 'Sebastián', 'Nicolás', 'Andrés', 'Gustavo'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Tucumán', 'La Plata', 'Mar del Plata', 'Salta', 'Santa Fe', 'Neuquén', 'Bahía Blanca', 'Posadas', 'Corrientes', 'San Juan', 'Jujuy', 'Paraná', 'Resistencia', 'San Luis', 'Formosa', 'Santiago del Estero', 'Ciudad de México', 'Bogotá', 'Lima', 'Santiago', 'Medellín', 'Guadalajara', 'Montevideo'];
const PRODUCTS = [{
  name: 'MegaPack + Método Gym Lleno',
  emoji: '🏆'
}, {
  name: 'MegaPack Boxeo Listo',
  emoji: '🥊'
}];
const LETTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
interface NotificationData {
  name: string;
  initial: string;
  city: string;
  product: {
    name: string;
    emoji: string;
  };
  timeAgo: number;
}
function generateRandomNotification(): NotificationData {
  const name = NAMES[Math.floor(Math.random() * NAMES.length)];
  const initial = LETTERS[Math.floor(Math.random() * LETTERS.length)];
  const city = CITIES[Math.floor(Math.random() * CITIES.length)];
  const product = PRODUCTS[Math.floor(Math.random() * PRODUCTS.length)];
  const timeAgo = Math.floor(Math.random() * 14) + 2;
  return {
    name,
    initial,
    city,
    product,
    timeAgo
  };
}
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  const [notification, setNotification] = useState<NotificationData | null>(null);
  useEffect(() => {
    if (isDismissed) return;
    let showTimeout: NodeJS.Timeout;
    let hideTimeout: NodeJS.Timeout;
    const cycleNotification = () => {
      setNotification(generateRandomNotification());
      setIsVisible(true);
      hideTimeout = setTimeout(() => {
        setIsVisible(false);
        const nextDelay = 25000 + Math.floor(Math.random() * 20000);
        showTimeout = setTimeout(cycleNotification, nextDelay);
      }, 4000);
    };
    const initialTimeout = setTimeout(cycleNotification, 20000);
    return () => {
      clearTimeout(initialTimeout);
      clearTimeout(showTimeout);
      clearTimeout(hideTimeout);
    };
  }, [isDismissed]);
  if (isDismissed || !notification) return null;
  return <div className={`fixed bottom-4 left-4 z-50 transition-all duration-500 ease-in-out ${isVisible ? 'translate-x-0 opacity-100' : '-translate-x-full opacity-0'}`} data-id="element-412">
      <div className="bg-[#0d0700] border border-[#F97316]/40 rounded-xl shadow-2xl p-4 max-w-[300px] sm:max-w-[320px] relative pr-8" data-id="element-413">
        <button onClick={() => setIsDismissed(true)} className="absolute top-2 right-2 text-gray-500 hover:text-white transition-colors p-1" aria-label="Cerrar notificación" data-id="element-414">
          ✕
        </button>
        <div className="flex items-center gap-2 mb-2" data-id="element-415">
          <div className="w-2 h-2 bg-[#F97316] rounded-full animate-pulse" data-id="element-416" />
          <span className="text-[#F97316] text-xs font-bold uppercase tracking-wider" data-id="element-417">
            Compra verificada
          </span>
        </div>
        <p className="text-white text-sm mb-1" data-id="element-418">
          <span className="font-bold" data-id="element-419">
            {notification.name} {notification.initial}.
          </span>{' '}
          de {notification.city}
        </p>
        <p className="text-gray-300 text-sm mb-2" data-id="element-420">
          compró{' '}
          <span className="text-[#F97316] font-bold" data-id="element-421">
            {notification.product.name} {notification.product.emoji}
          </span>
        </p>
        <p className="text-gray-500 text-xs" data-id="element-422">
          hace {notification.timeAgo} minutos
        </p>
      </div>
    </div>;
}